@for (item of data.entities; track item) {
  <div class="article">
    @if (item.path) {
      <a [routerLink]="item.path"
        [attr.data-test-id]="'sidebar-articles-link-' + (item?.path | slugify)"
        >
        @if ((item.fieldIntroductionImage | arrayFirst); as Image) {
          <img
            src="{{ Image.url }}"
            alt="{{ Image.alt }}"
            width="100%"
            />
        }
        <h2>{{ item.title }}</h2>
      </a>
    }
    <time
      >{{ item.fieldAuthor }} {{ item.created*1000 | date:"dd.MM.yyyy" }}</time
      >
    </div>
  }
